var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44263 1.9178L6.00792 1.76507L4.45576 0L3.98674 2.31118L4.47659 2.17883L6.03653 9.06845L1.11888 14.1443L0.739801 13.762L0 16L2.2194 15.254L1.82307 14.8544L6.79549 9.72203H13.9075V10.277L16 9.22203L13.9075 8.16702V8.72203H6.98324L5.44263 1.9178Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 7.5,
    width: 3,
    height: 3,
    fill: "black",
    stroke: "#60D9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "black",
    stroke: "#60D9FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "black",
    stroke: "#60D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L3 9L8.5 4L11 7L6 12Z",
    fill: "#FFD200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12V9L6 12H3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9C4.66667 7.5 8.1 4.4 8.5 4L11 7L6 12H3V9Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12L3 10.5V12H4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcs);
export default __webpack_public_path__ + "static/media/ucs.061b7d68b12ff5eb405bbc213784b5ea.svg";
export { ForwardRef as ReactComponent };